import { ProductConfigurationCluster } from "./product-configuration-cluster";
import { NetworkProductConfigurationCluster } from "./network-product-configuration";
import { TransactionConfiguration } from "./transaction-configuration";
import { MedicalPrescriptionConfiguration } from "./medical-prescription-configuration";
import { LifeCycleConfiguration } from "./life-cycle-configuration";
import { BeneficiaryConfiguration } from "./beneficiary-configuration";

export class BenefitConfiguration {
  private id: string;
  private companyFiscalNumber: string;
  private productConfiguration: ProductConfigurationCluster;
  private networkConfiguration: NetworkProductConfigurationCluster;
  private transactionConfiguration: TransactionConfiguration;
  private medicalPrescriptionConfiguration: MedicalPrescriptionConfiguration;
  private beneficiaryConfiguration: BeneficiaryConfiguration;
  private lifeCycleConfiguration: LifeCycleConfiguration;

  setId(id: string): void {
    this.id = id;
  }

  getId(): string {
    return this.id;
  }

  setCompanyFiscalNumber(fiscalNumber: string): void {
    this.companyFiscalNumber = fiscalNumber;
  }

  getCompanyFiscalNumber(): string {
    return this.companyFiscalNumber;
  }

  setProductConfiguration(productConfiguration: ProductConfigurationCluster): void {
    this.productConfiguration = productConfiguration;
  }

  getProductConfiguration(): ProductConfigurationCluster {
    return this.productConfiguration;
  }

  hasProductConfiguration() {
    return !!this.productConfiguration;
  }

  setNetworkProductConfiguration(networkProductConfiguration: NetworkProductConfigurationCluster): void {
    this.networkConfiguration = networkProductConfiguration;
  }

  getNetworkProductConfiguration(): NetworkProductConfigurationCluster {
    return this.networkConfiguration;
  }

  hasNetworkProductConfiguration(): boolean {
    return !!this.networkConfiguration;
  }

  setTransactionConfiguration(transactionConfiguration: TransactionConfiguration): void {
    this.transactionConfiguration = transactionConfiguration;
  }

  getTransactionConfiguration(): TransactionConfiguration {
    return this.transactionConfiguration;
  }

  hasTransactionConfiguration(): boolean {
    return !!this.transactionConfiguration;
  }

  setMedicalPrescriptionConfiguration(medicalPrescriptionConfiguration: MedicalPrescriptionConfiguration): void {
    this.medicalPrescriptionConfiguration = medicalPrescriptionConfiguration;
  }

  getMedicalPrescriptionConfiguration(): MedicalPrescriptionConfiguration {
    return this.medicalPrescriptionConfiguration;
  }

  hasMedicalPrescriptionConfiguration(): boolean {
    return !!this.medicalPrescriptionConfiguration;
  }

  setBeneficiaryConfiguration(value: BeneficiaryConfiguration): void {
    this.beneficiaryConfiguration = value;
  }

  getBeneficiaryConfiguration(): BeneficiaryConfiguration {
    return this.beneficiaryConfiguration;
  }

  hasBeneficiaryConfiguration(): boolean {
    return !!this.beneficiaryConfiguration;
  }

  setLifeCycleConfiguration(lifeCycleConfiguration: LifeCycleConfiguration): void {
    this.lifeCycleConfiguration = lifeCycleConfiguration;
  }

  getLifeCycleConfiguration(): LifeCycleConfiguration {
    return this.lifeCycleConfiguration;
  }

  hasLifeCycleConfiguration(): boolean {
    return !!this.lifeCycleConfiguration;
  }

  hasAllConfiguration(): boolean {
    return (
      !!this.productConfiguration &&
      !!this.networkConfiguration &&
      !!this.transactionConfiguration &&
      !!this.medicalPrescriptionConfiguration &&
      !!this.beneficiaryConfiguration &&
      !!this.lifeCycleConfiguration
    );
  }
}
